import React, { Component } from 'react';
import './AuthLayout.scss';

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authlayout-main">
      {children}
    </div>
  );
};

export default AuthLayout;
